import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// UTILS
import { isObject, validationErrorsToString } from '../../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../../components/Button';
import LoadingSpinner from '../../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../../components/GlobalModal';

interface DeclineDeleteOrganisationModalTypes {
	organisationId?: string;
	closeModal?: closeModalType;
	onDeclineComplete?: () => void;
}

const DeclineDeleteOrganisationModal: React.FC<DeclineDeleteOrganisationModalTypes> = ({
	organisationId,
	closeModal,
	onDeclineComplete
}) => {
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');
	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmDecline = async () => {
		if (!organisationId) {
			return;
		}

		setIsLoading(true);

		const response = await apibridge.postOrganisationDeclineDeletion({ id: organisationId });

		if (isObject(response) && response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			if (onDeclineComplete) {
				onDeclineComplete();
			}
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to <strong>Decline</strong> organisation deletion? The organisation will remain{' '}
									<strong>Deactivated</strong>.
								</h2>

								<section className="actions mtop-30">
									<Button className="btn-primary full-width" onClick={confirmDecline}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default DeclineDeleteOrganisationModal;
